import "./styles/Header.css";

function Header() {
  return (
    <div className="header-container">
      <h1 className="title">Pokémon Memory Game</h1>
    </div>
  );
}

export default Header;
